.loading-wrap {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99999999;
  width: 100%;
  height: 100%;
  min-height: 200px;
  background: rgba(0, 0, 0, 0);
  .loading-content {
    position: relative;
    width: 80px;
    height: 80px;
  }
}
